export const LOCALES = {
    ENGLISH_US: "en-US",
    ENGLISH_CA: "en-CA",
    SPANISH_MX: "es-MX",
    FRENCH_CA: "fr-CA"
}